module.exports = __webpack_public_path__ + "fonts/c8cda5a.ttf";